"use client";

import React from "react";
import { motion } from "framer-motion";

import Image from "next/image";
import { PortableText } from "next-sanity";
import { customRichTextComponent } from "@/sanity/sanityPortableText";
import Video from "@/components/global/Video";

import aftermovieBG from "@/public/krypto-day/aftermovie-bg.png";

import { PageKryptoDaySchema } from "@/sanity/pages/PageKryptoDayTemplate";

export default function KryptoDayAftermovie({
  data,
}: {
  data: PageKryptoDaySchema;
}) {
  return (
    <section className="relative lg:px-0 px-[2rem] pt-[12rem] z-[2] pb-[8rem] overflow-clip lg:pt-[25rem]">
      <div className="">
        {/* Title area */}
        <div className="relative mb-[6rem] z-[2]">
          <Image
            src={aftermovieBG}
            alt=""
            className="absolute top-0 left-1/2 -translate-x-1/2 lg:-translate-y-[38%] z-[1] lg:scale-100 scale-[300%] -translate-y-[12%]"
            quality={100}
          />
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="relative z-[5] w-[80%] lg:w-auto mx-auto"
          >
            {data?.aftermovieTitle && (
              <PortableText
                value={data?.aftermovieTitle ?? []}
                components={customRichTextComponent({
                  block: {
                    h6: ({ children }) => (
                      <div className="mx-auto font-bold uppercase bg-white bg-opacity-10 rounded-full border border-white border-opacity-20 px-[2rem] py-[1.5rem] leading-[1rem] text-[1.75rem] backdrop-blur-[2rem] w-fit">
                        {children}
                      </div>
                    ),
                    h2: ({ children }) => (
                      <h2 className="text-[4rem] lg:text-[7rem] font-[600] tracking-[-.14rem] gradient-title !text-white/80 w-full text-center">
                        {children}
                      </h2>
                    ),
                    normal: ({ children }) => (
                      <p className="mx-auto text-center lg:w-fit text-white/70 w-[80%]">
                        {children}
                      </p>
                    ),
                  },
                })}
              />
            )}
          </motion.div>
        </div>

        <div className="relative w-[min(149.5rem,100%)] mx-auto">
          <div className="absolute top-0 right-0 left-0 w-full bg-gradient-to-r from-transparent to-transparent via-[#61FFCE] z-[6] h-[.5rem]" />
          <div className="relative bg-gradient-to-b p-[.5rem] from-[#61FFCE]/30 to-[#007A54]/20 z-[5] rounded-[1.5rem] lg:rounded-[2rem] lg:p-[1rem]">
            <div className="relative [&>div]:h-full [&_video]:!object-cover aspect-video">
              <Video videoData={data?.aftermovieVideo} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
